var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dtp-main"},[_c('div',[_vm._v(_vm._s(_vm.selectedDateTime))]),_c('DateTimePicker',{attrs:{"value":_vm.selectedDateTime},on:{"update:value":function($event){_vm.selectedDateTime=$event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }